import React, { useMemo } from "react";
import styles from "./reports.module.scss";
import Input from "components/Input";
import Table from "components/Table";
import { companyDocsColumns } from "./columns";

const data = [
    {
        jurisdiction: "FED",
        label: "Federal",
        year: "2024",
        field_on: "Thursday, Jun, 2024",
    }
]

const CompanyTaxDocs = () => {
    const columns = useMemo(() => {
        return companyDocsColumns();
    }, [])
    return (
        <div className={styles.companyDocsContainer}>
            <div className={styles.header}>
                <Input
                    placeholder="Search by Name, Email, or Id"
                    style={{ minWidth: "300px" }}
                />
            </div>
            <Table
                headers={columns}
                data={data}
                containerStyle={{
                    border: "none",
                    borderRadius: "0px"
                }}
            />
        </div>
    )
}

export default CompanyTaxDocs;